// src/components/landing/ListingImage.tsx
import React, { useState } from "react";
import { ImageOff } from "lucide-react";

export function ListingImage({
  photos,
  alt,
  className,
}: {
  photos: string[];
  alt: string;
  className?: string;
}) {
  const [idx, setIdx] = useState(0);
  const [failed, setFailed] = useState(false);
  const src = !failed ? photos?.[idx] : undefined;

  if (!src) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 ${
          className ?? ""
        }`}
      >
        <ImageOff className="h-6 w-6 text-slate-300" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => {
        if (idx < photos.length - 1) setIdx((i) => i + 1);
        else setFailed(true);
      }}
    />
  );
}